/* eslint-disable indent */
import { computed, defineComponent, h } from "vue";
import { treeNodeProps } from "element-plus/es/components/tree-v2/src/virtual-tree";
import { getPrefixCls } from "@vue-admin-core/utils/const";
const prefixCls = getPrefixCls("tree-node");
export default defineComponent({
  name: "VacTreeLine",
  props: {
    node: treeNodeProps.node,
    treeData: {
      type: Array
    },
    indent: {
      type: Number,
      default() {
        return 16;
      }
    }
  },
  setup(props, { slots }) {
    const lastnodeArr = computed(() => {
      const lastnodeArr = [];
      let currentNode: any = props.node;
      while (currentNode) {
        let parentNode = currentNode.parent;
        // 兼容element-plus的 el-tree-v2 (Virtualized Tree 虚拟树)
        if (currentNode.level === 1 && !currentNode.parent) {
          // el-tree-v2的第一层node是没有parent的，必需 treeData 创建一个parent
          if (!props.treeData || !Array.isArray(props.treeData)) {
            throw Error(
              "if you using el-tree-v2 (Virtualized Tree) of element-plus,element-tree-line required data."
            );
          }
          parentNode = {
            children: Array.isArray(props.treeData)
              ? props.treeData.map((item: any) => {
                  return { ...item, key: item.id };
                })
              : [],
            level: 0,
            key: "node-0",
            parent: null
          };
        }
        if (parentNode) {
          // element-plus的 el-tree-v2 使用的是children和key， 其他使用的是 childNodes和id
          const index = (parentNode.children || parentNode.childNodes).findIndex(
            (item: any) => (item.key || item.id) === (currentNode.key || currentNode.id)
          );
          lastnodeArr.unshift(index === (parentNode.children || parentNode.childNodes).length - 1);
        }
        currentNode = parentNode;
      }
      return lastnodeArr;
    });

    const lineNodes = computed(() => {
      const lineNodes = [];
      for (let i = 1; i < props.node.level; i++) {
        if (lastnodeArr.value[i] && props.node.level - 1 !== i) {
          continue;
        }
        lineNodes.push(
          h("span", {
            class: {
              [`${prefixCls}-line-var`]: true,
              "last-node-isLeaf-line": lastnodeArr.value[i] && props.node.level - 1 === i
            },
            style: { left: props.indent * i - 6 + "px" }
          })
        );
      }

      return lineNodes;
    });
    return () => {
      return h(
        "span",
        {
          class: `${prefixCls}-label-wrapper`
        },
        [
          slots.default
            ? slots.default({ node: props.node, data: props.node.data })
            : h("span", { class: "el-tree-node__label" }, [props.node.label]),
          ...lineNodes.value,
          props.node.level !== 1
            ? h("span", {
                class: `${prefixCls}-line-hor`,
                style: {
                  width: "10px",
                  left: (props.node.level - 1) * props.indent - 6 + "px"
                }
              })
            : null
        ]
      );
    };
  }
});
